import Showcase from './Showcase.vue'
import ShowcaseOneBtn from './ShowcaseOneBtn.vue'
import ShowcaseV2 from './ShowcaseV2.vue'
import ShowcaseStarzaym from './ShowcaseStarzaym.vue'
import ShowcaseVamZaim from './ShowcaseVamZaim.vue'
import ShowcaseYazaym from './ShowcaseYazaym.vue'
import ShowcaseWbzaym from './ShowcaseWbzaym.vue'
import ShowcaseOzzaym from './ShowcaseOzzaym.vue'
import ShowcaseBzaym from './ShowcaseBzaym.vue'
import ShowcaseZaymna5 from './ShowcaseZaymna5.vue'
import ShowcaseFixzaem from './ShowcaseFixzaem.vue'
import ShowcaseDizaym from './ShowcaseDizaym.vue'
import ShowcaseZaymelo from './ShowcaseZaymelo.vue'
import Showcase365zaym from './Showcase365zaym.vue'
import ShowcaseUltrazaem from './ShowcaseUltrazaem.vue'
import Showcase23zaym from './Showcase23zaym.vue'
import ShowcaseZaymtorus from './ShowcaseZaymtorus.vue'
import ShowcaseKredifka from './ShowcaseKredifka.vue'
import ShowcaseOkredit from './ShowcaseOkredit.vue'
import ShowcaseFilters from './ShowcaseFilters.vue'
import TemplatesShowcaseV1 from './TemplatesShowcaseV1.vue'
import TemplatesShowcaseV2 from './TemplatesShowcaseV2.vue'
import TemplatesShowcaseV3 from './TemplatesShowcaseV3.vue'
import TemplatesShowcaseV4 from './TemplatesShowcaseV4.vue'


export default {
    'v-showcase-default': Showcase,
    'v-showcase-OneBtn': ShowcaseOneBtn,
    'v-showcase-v2': ShowcaseV2,
    'v-showcase-vamzaim': ShowcaseVamZaim,
    'v-showcase-yazaym': ShowcaseYazaym,
    'v-showcase-wbzaym': ShowcaseWbzaym,
    'v-showcase-ozzaym': ShowcaseOzzaym,
    'v-showcase-starzaym': ShowcaseStarzaym,
    'v-showcase-zaymstar': ShowcaseStarzaym,
    'v-showcase-bzaym': ShowcaseBzaym,
    'v-showcase-zaymna5': ShowcaseZaymna5,
    'v-showcase-fixzaem': ShowcaseFixzaem,
    'v-showcase-dizaym': ShowcaseDizaym,
    'v-showcase-ultrazaem': ShowcaseUltrazaem,
    'v-showcase-zaymelo': ShowcaseZaymelo,
    'v-showcase-23zaym': Showcase23zaym,
    'v-showcase-365zaym': Showcase365zaym,
    'v-showcase-zaymtorus': ShowcaseZaymtorus,
    'v-showcase-kredifka': ShowcaseKredifka,
    'v-showcase-okredit': ShowcaseOkredit,
    'v-showcase-templates-showcase-v1': TemplatesShowcaseV1,
    'v-showcase-templates-showcase-v2': TemplatesShowcaseV2,
    'v-showcase-templates-showcase-v3': TemplatesShowcaseV3,
    'v-showcase-templates-showcase-v4': TemplatesShowcaseV4,


    //filters
    'v-showcase-filter-default': ShowcaseFilters,

}
